import React from 'react';
// shapes

// components

import { ContentHeader } from "../ContentHeader";
export var OrderStatusPopup = function OrderStatusPopup(_ref) {
  var texts = _ref.texts;
  return /*#__PURE__*/React.createElement(ContentHeader, {
    description: texts.description,
    img: texts.img,
    title: texts.title,
    "data-t-id": "common-OrderStatusPopup"
  });
};